import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { animated } from "react-spring";

const styles = () =>
  makeStyles(() => ({
    title: {
      fontFamily: "Manrope",
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "22px",
      color: "#465869",
    },
  }));

export const Subtitle = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));

export const TitleWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "0",
}));

interface CollapsePanelProps {
  filledBackground: boolean;
}
export const CollapsePanel = styled("div")(({ filledBackground }: CollapsePanelProps) => ({
  width: "100%",
  textAlign: "left",
  border: !filledBackground ? "1px solid #E4E7EC" : "none",
  borderRadius: "12px",
  background: !filledBackground ? "none" : "#EDF5FB",
}));

interface PanelContentHeaderProps {
  isCollapsed: boolean;
}
export const CollapseHeader = styled("header")(({ isCollapsed }: PanelContentHeaderProps) => ({
  borderTopLeftRadius: "12px",
  borderTopRightRadius: "12px",
  borderBottomLeftRadius: isCollapsed ? "12px" : "0px",
  borderBottomRightRadius: isCollapsed ? "12px" : "0px",
  background: "#EDF5FB",
  color: "#465869",
  padding: "12px 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  cursor: "pointer",
}));

export const PanelContent = styled(animated.div)(() => ({
  overflow: "hidden",
}));

export default styles;
